import { render } from "./FilterShortlistedSpeakers.vue?vue&type=template&id=de6a3412&scoped=true"
import script from "./FilterShortlistedSpeakers.vue?vue&type=script&lang=js"
export * from "./FilterShortlistedSpeakers.vue?vue&type=script&lang=js"

import "./FilterShortlistedSpeakers.vue?vue&type=style&index=0&id=de6a3412&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de6a3412"]])

export default __exports__